/* USDO: one-form installation quotes on the Quick Quote page.
   Shows the installation questions only when "Include assembly/installation?" is Yes,
   requires them in that case, and pre-selects Yes when the shopper arrives with ?install=1.
   Field IDs come from Quick Quote > Custom Form Fields. */
(function () {
  if (location.pathname.indexOf('/apps/request-quote') !== 0) return;

  var TRIGGER = 7489;                                  // Include assembly/installation?
  var FIELDS = [9854, 9855, 9856, 9857, 9858, 9859, 9860, 9861, 9862, 9863];
  var REQUIRED_TEXT = [9854];                           // deadline
  var REQUIRED_RADIO = [9857, 9858, 9859, 9860, 9861, 9862];
  var REQUIRED_ALL_CHECKS = [9863];                     // both acknowledgments
  var wantsInstall = /[?&]install=1\b/.test(location.search);
  var preselected = false;

  function el(id) { return document.getElementById('customField' + id); }
  function group(id) { var e = el(id); return e ? e.closest('.quote-input-group') : null; }
  function triggerSelect() { return el(TRIGGER); }
  function isYes() {
    var s = triggerSelect();
    if (!s || s.selectedIndex < 0) return false;
    return (s.options[s.selectedIndex].text || '').trim().toLowerCase() === 'yes';
  }

  function ensureHeading() {
    if (document.getElementById('usdo-install-heading')) return;
    var first = group(FIELDS[0]);
    if (!first) return;
    var h = document.createElement('div');
    h.id = 'usdo-install-heading';
    h.innerHTML = '<p style="font-weight:700;font-size:1.05em;margin:18px 0 4px">Installation details</p>' +
      '<p style="margin:0 0 10px;font-size:.92em;opacity:.8">These help us price your installation accurately. Fields marked * are required.</p>';
    first.parentNode.insertBefore(h, first);
  }

  // Radio and checkbox questions have long labels, so stack the label above the choices.
  var STACK = REQUIRED_RADIO.concat(REQUIRED_ALL_CHECKS);
  function stackLayout() {
    if (!document.getElementById('usdo-install-style')) {
      var st = document.createElement('style');
      st.id = 'usdo-install-style';
      st.textContent =
        '.usdo-stack{flex-direction:column!important;align-items:flex-start!important;gap:6px;margin-bottom:8px}' +
        '.usdo-stack .quote-input-label{width:auto!important;max-width:none!important}' +
        '.usdo-stack .quote-input-radio{display:flex!important;flex-wrap:wrap;gap:4px 22px;width:auto!important}' +
        '.usdo-stack .quote-input-checkbox{display:flex!important;flex-direction:column;gap:8px;width:auto!important}' +
        '.usdo-stack label{display:inline-flex!important;align-items:flex-start;gap:8px;margin:0}' +
        '.usdo-stack label input{margin-top:.3em;flex:none}';
      document.head.appendChild(st);
    }
    STACK.forEach(function (id) { var g = group(id); if (g) g.classList.add('usdo-stack'); });
  }

  function markRequired() {
    REQUIRED_TEXT.concat(REQUIRED_RADIO, REQUIRED_ALL_CHECKS).forEach(function (id) {
      var g = group(id);
      if (!g || g.querySelector('.usdo-req')) return;
      var label = g.querySelector('.quote-input-label');
      if (label) label.insertAdjacentHTML('beforeend', ' <span class="usdo-req" style="color:red">*</span>');
    });
  }

  function apply() {
    var on = isYes();
    ensureHeading();
    var h = document.getElementById('usdo-install-heading');
    if (h) h.style.display = on ? '' : 'none';
    FIELDS.forEach(function (id) { var g = group(id); if (g) g.style.display = on ? '' : 'none'; });
    if (!on) clearErrors();
  }

  function preselect() {
    if (preselected || !wantsInstall) return;
    var s = triggerSelect();
    if (!s) return;
    for (var i = 0; i < s.options.length; i++) {
      if ((s.options[i].text || '').trim().toLowerCase() === 'yes') {
        s.selectedIndex = i;
        s.dispatchEvent(new Event('change', { bubbles: true }));
        preselected = true;
        break;
      }
    }
  }

  function missing() {
    var out = [];
    REQUIRED_TEXT.forEach(function (id) { var e = el(id); if (e && !e.value.trim()) out.push(id); });
    REQUIRED_RADIO.forEach(function (id) { var g = group(id); if (g && !g.querySelector('input[type=radio]:checked')) out.push(id); });
    REQUIRED_ALL_CHECKS.forEach(function (id) {
      var g = group(id); if (!g) return;
      var boxes = g.querySelectorAll('input[type=checkbox]');
      for (var i = 0; i < boxes.length; i++) { if (!boxes[i].checked) { out.push(id); break; } }
    });
    return out;
  }

  function clearErrors() {
    FIELDS.forEach(function (id) { var g = group(id); if (g) g.style.outline = ''; });
    var m = document.getElementById('usdo-install-error'); if (m) m.remove();
  }

  function showErrors(ids, button) {
    clearErrors();
    ids.forEach(function (id) { var g = group(id); if (g) { g.style.outline = '2px solid #b3261e'; g.style.outlineOffset = '4px'; } });
    var m = document.createElement('p');
    m.id = 'usdo-install-error';
    m.setAttribute('role', 'alert');
    m.style.cssText = 'color:#b3261e;font-weight:600;margin:10px 0';
    m.textContent = 'Please answer the highlighted installation questions so we can quote your installation.';
    button.parentNode.insertBefore(m, button);
    var first = group(ids[0]); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Runs before Quick Quote's own submit handler.
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button');
    if (!b || !/submitQuote/.test(b.getAttribute('ng-click') || '')) return;
    if (!isYes()) { clearErrors(); return; }
    var ids = missing();
    if (ids.length) { e.preventDefault(); e.stopImmediatePropagation(); showErrors(ids, b); }
    else clearErrors();
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'customField' + TRIGGER) apply();
    else if (document.getElementById('usdo-install-error') && missing().length === 0) clearErrors();
  });

  // Quick Quote builds the form after load, so wait for it.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (triggerSelect() && group(FIELDS[0])) {
      clearInterval(timer);
      markRequired();
      stackLayout();
      preselect();
      apply();
      setTimeout(apply, 500);
      setTimeout(apply, 1500);
    } else if (tries > 60) {
      clearInterval(timer);
    }
  }, 250);
})();
